module.exports = __webpack_public_path__ + "img/mastercard-dark.01720cf0.svg";